<template>
	<c-dialog ref="dialog" :title="title" height="50vh" @resolve="resolveHandle">
		<c-form>
			<c-form-item :label="label" required>
				<c-input v-model="remark" type="textarea" :placeholder="placeholder"></c-input>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
	export default {
		name: 'remark',

		props: {
			title: String,
			label: String,
			placeholder: String
		},

		data() {
			return {
				remark: ''
			}
		},

		methods: {
			open(data = {}) {
				this.remark = '';
				this.$refs.dialog.open();
			},

			resolveHandle(stop, next) {
				this.$emit('resolve', stop, next, this.remark);
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>
